<template>
  <div class="app-activation-info">
    <slot name="txtBefore"></slot>
    <b-form
      inline
      @submit.prevent="next()"
      :id="'form' + _uid"
      :novalidate="true"
      data-form-activation-info
    >
      <slot name="txtBeforeActivationMsisdn"></slot>
      <div class="input-column">
        <b-form-group
          label="Aktivierungsdaten"
          label-class="visually-hidden"
        >
          <b-row>
            <b-col cols="12" md="" class="msisdn-label-col">
              <label :for="'activation-msisdn-input' + _uid" class="mandatory d-inline-block">
                <slot name="lblMsisdn">Deine Rufnummer</slot>
              </label>
            </b-col>
            <b-col cols="12" md="" class="msisdn-input-col">
              <b-form-group _id="'activation-msisdn' + _uid" :label-for="'activation-msisdn-input' + _uid">
                <b-form-input
                  :id="'activation-msisdn-input' + _uid"
                  data-msisdn
                  type="text"
                  name="msisdn"
                  required
                  @input="$v.msisdn.$touch"
                  v-model.trim="msisdn"
                  :state="isValid('msisdn')"
                ></b-form-input>
                <b-form-invalid-feedback v-if="displayErrorMessage">
                  <slot name="errorActivationMsisdn">Du hast keine gültige Rufnummer angegeben.
                  </slot>
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <slot name="txtAfterActivationMsisdn"></slot>
          <slot name="txtBeforeActivationCode"></slot>
          <b-row>
            <b-col cols="12" md="" class="code-label-col">
              <label :for="'activation-code-input' + _uid" class="mandatory d-inline-block">
                <slot name="lblActivationCode">Die letzten fünf Stellen Deiner SIM-Kartennummer</slot>
              </label>
            </b-col>
            <b-col cols="12" md="" class="code-input-col">
              <b-form-group :id="'activation-code' + _uid" :label-for="'activation-code-input' + _uid">
                <b-form-input
                  :id="'activation-code-input' + _uid"
                  data-activation-code
                  type="text"
                  required
                  :state="isValid('activationCode')"
                  @input="$v.activationCode.$touch"
                  v-model="activationCode"
                ></b-form-input>
                <b-form-invalid-feedback v-if="displayErrorMessage">
                  <slot name="errorActivationCode">Du hast kein gültigen Aktivierungscode
                    eingegeben.
                  </slot>
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <slot name="txtAfterInputColumn"></slot>
        </b-form-group>
      </div>
      <slot name="txtAfterActivationCode"></slot>
      <div class="btn-column col-12">
        <slot name="txtBeforeBtnNext"></slot>
        <b-overlay :show="loading" spinner-small>
          <b-button :id="'submit-'+_uid" type="submit" variant="primary" :disabled="$v.$invalid || loading">
            <slot name="btnNext">weiter</slot>
          </b-button>
        </b-overlay>
      </div>
      <slot name="txtAfterBtnNext"></slot>
    </b-form>
    <slot name="txtAfter"></slot>
  </div>
</template>

<script>
import { BButton, BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BOverlay } from 'bootstrap-vue'
import { validationMixin } from 'vuelidate'
import { numeric, required, maxLength, minLength, helpers } from 'vuelidate/lib/validators'
import { mapActions, mapGetters } from 'vuex'
import processSteps from '@/mixins/processSteps'
import { stepName as nextProcessStep } from '../PersonalData/EnterPersonalData.vue'
import isValid from '@/mixins/isValid'
import preFilledInput from '@/mixins/preFilledInput'
import pplusAcceptor from '@/mixins/pplusAcceptor'
import orderByAgentChecker from '@/mixins/orderByAgentChecker'

const isPhoneNumber = helpers.regex('phoneNumber', /^((\+?49)|(0049)|(0))1[0-9]{5,15}$/)
const OTHER_BRAND = 'OTHER_BRAND'
export const stepName = 'activationInfo'

export default {
  name: 'ActivationInfo',
  data () {
    return {
      msisdn_: null,
      activationCode_: null,
      displayErrorMessage: false,
      loading: false
    }
  },
  props: {
    activationCodeMin: {
      type: Number,
      default: 4
    },
    activationCodeMax: {
      type: Number,
      default: 5
    },
    otherBrandUrl: {
      type: String,
      default: '#'
    }
  },
  components: {
    BButton, BFormGroup, BFormInput, BForm, BFormInvalidFeedback, BOverlay
  },
  methods: {
    next () {
      if (this.$v.$invalid) {
        return
      }
      this.loading = true
      this.activationInfo({
        msisdn: this.msisdn,
        activationCode: this.activationCode,
        nextStep: this.nextStep
      })
        .then((type) => {
          if (type === OTHER_BRAND) {
            window.location.href = this.otherBrandUrl + this.msisdn
          }
          this.loading = false
          this.msisdn = null
          this.activationCode = null
        }, () => {
          this.loading = false
        })
    },
    ...mapActions('activation/info', [
      'activationInfo'
    ])
  },
  computed: {
    ...mapGetters('activation/info', {
      getMsisdn: 'msisdn',
      getActivationCode: 'activationCode'
    })
  },
  mixins: [
    validationMixin,
    isValid,
    pplusAcceptor(),
    orderByAgentChecker(),
    processSteps(stepName, stepName, nextProcessStep), // prev = current, because first step
    preFilledInput('activationCode', 'getActivationCode'),
    preFilledInput('msisdn', 'getMsisdn')
  ],
  validations () {
    return {
      msisdn: {
        required,
        isPhoneNumber
      },
      activationCode: {
        required,
        numeric,
        minLength: minLength(this.activationCodeMin),
        maxLength: maxLength(this.activationCodeMax)
      }
    }
  }
}
</script>
